import type { SignInConfig } from '#types/config/components/form/signIn'

export default {
  brandClasses: {
    forgotPassword: 'subtitle-5 mt-1',
    heading: 'subtitle-4',
    signUp: 'mt-6 subtitle-4'
  }
} satisfies SignInConfig
